import React, {useState} from "react";
import Modal from "react-modal";
import {Button} from "@mui/material";
import Linechart from "./Linechart";
import { sendGetRequest } from '../../../../helper/Helper'; 

const Popup = ({ modalIsOpen, closeModal }) => {
  const [fullData, setFullData] = useState([]);

  const handleModalOpen = async () => {
    const response = await sendGetRequest('historical-data/volume-price-marketcap');
    if (response && response.status === 200) {
      setFullData(response.data);
    }
  };

  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal" onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="PTGCSEC popupcenter ">
            <div className="container">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid"/></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont">Market Cap Vs Price Vs Volume</h2>
            </div>
            <div className="row justify-content-center mt-4">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="">
                <div className="bSRIN overHide ">
                  <div className=" snstakes  mt-0 w-5100" style={{ border: '0px', borderRadius:'0px', borderBottom: '0px solid #383835' }}>
                    <div className="row justify-content-center align-items-center">
                      <div className="col-md-12" style={{ border: "0px" }}>
                        <Linechart fullData={fullData}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
    </Modal>
    </>
  );
};

export default Popup;